import { BMP_Investment } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPInvestments = (user_id?: number): Promise<BMP_Investment[]> => {
    return new Promise<BMP_Investment[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/investments/${user_id}`).then((response) => {
            resolve(response.data as BMP_Investment[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};